export default __webpack_public_path__ + "static/media/PhotoAdd.99f1ff35.svg";